import { Component } from '@angular/core';

@Component({
	selector: 'sgp-skeleton-visualizar-edital',
	templateUrl: './skeleton-visualizar-edital.component.html'
})
export class SkeletonVisualizarEditalComponent {}
